<!--
 * @Author: WLL
 * @Date: 2020-03-27 18:40:27
 * @LastEditors: WLL
 * @LastEditTime: 2020-03-30 13:04:26
 * @Description: file content
 -->
<template>
  <div>
    <div>
      <span>多选（全选）：</span>
      <SjAutoComplete
        v-model="value"
        style="width: 200px;"
        :options="options"
        showIcon
        multiple
        filterable
        clearable
        :select-all.sync="selectAll"
        enable-select-all
        appendToBody
      ></SjAutoComplete>
    </div>

    <div style="margin-top: 10px;">
      <span>单选：</span>
      <SjAutoComplete
        v-model="value1"
        style="width: 200px;"
        :options="options"
        showIcon
      ></SjAutoComplete>
    </div>

    <div style="margin-top: 10px;">
      <span>size：</span>
      <SjAutoComplete
        v-model="value1"
        class="demo_item"
        size="large"
        :options="options"
        showIcon
      ></SjAutoComplete>
      <SjAutoComplete
        v-model="value1"
        class="demo_item"
        size="middle"
        :options="options"
        showIcon
      ></SjAutoComplete>
      <SjAutoComplete
        v-model="value1"
        class="demo_item"
        size="default"
        :options="options"
        showIcon
      ></SjAutoComplete>
      <SjAutoComplete
        v-model="value1"
        class="demo_item"
        size="small"
        :options="options"
        showIcon
      ></SjAutoComplete>
      <SjAutoComplete
        v-model="value1"
        class="demo_item"
        size="mini"
        :options="options"
        showIcon
      ></SjAutoComplete>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectAll: "none",
      value: [],
      value1: null,
      options: [
        {
          label: "testq",
          ignoreCount: true, //取消算入过滤计数
          value: "q",
          icon: "https://www.baidu.com/img/bd_logo1.png?where=super"
        },
        {
          label: "category1",
          options: [
            {
              label: "test1",
              value: 1,
              disabled: true
            },
            {
              label: "test2",
              value: 2,
              icon: require("../../../assets/image/logo.png")
            },
            {
              label: "category2",
              options: [
                {
                  label: "test3",
                  value: 3
                },
                {
                  label: "test4",
                  value: 4
                }
              ]
            }
          ]
        }
      ]
    };
  }
};
</script>

<style scoped lang="less">
.demo_item {
  width: 150px;
  margin-right: 10px;
  &:last-child {
    margin-right: 0;
  }
}
</style>
